import { useTranslation } from 'react-i18next';
import type { UUID } from '@/api/types';
import { KostenBereich } from './KostenBereich';

interface SachkostenTabProps {
  planId: UUID;
  disabled: boolean;
  onMutated: () => void;
}

/**
 * Sachkosten-Reiter: der Bereich "sach" der schlanken Kostenansicht.
 *
 * Fuenf Punkte — Regulaere Kosten, Verpflegung Kinder, Miete,
 * Mietnebenkosten und Besondere Kosten. Nur der letzte traegt eigene
 * Positionen; die uebrigen sind je ein Jahresbetrag. Die gesamte Logik
 * steckt in :func:`KostenBereich`, weil der Personalkosten-Reiter denselben
 * Aufbau mit seinen zwei Punkten zeigt.
 */
export function SachkostenTab({ planId, disabled, onMutated }: SachkostenTabProps) {
  const { t } = useTranslation('sachkosten');
  return (
    <KostenBereich
      planId={planId}
      disabled={disabled}
      onMutated={onMutated}
      bereichCode="sach"
      titel={t('sachkosten:section.title')}
      summeLabel={t('sachkosten:summe.gesamt')}
    />
  );
}
